import { z } from 'zod';

export const PaginationResponseSchema = z.object({
    total_items: z.number().optional(),
    total_pages: z.number().optional(),
    current_page: z.number().optional(),
    limit: z.number().optional(),
    has_next: z.boolean().optional(),
    has_prev: z.boolean().optional(),
});
export type PaginationDto = z.infer<typeof PaginationResponseSchema>;
export type TPaginationResponse = z.infer<typeof PaginationResponseSchema>;
